import { instance } from "libs/api";

import { AdminEmailSuggestion } from "../../emailNotifications.types";
import { ApiRoutesEmailNotifications } from "../../constants";

export const requestGetAdminSuggestions = async (): Promise<
  AdminEmailSuggestion[]
> => {
  return await instance.get(ApiRoutesEmailNotifications.AdminSuggestions);
};
